module.exports = __webpack_public_path__ + "media/images/flags/1x1/hmd-85e716171fde0dbf0feb8d78f5bcba9a.svg";